const slugify = (value) => String(value || '')
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/(^-|-$)/g, '');

export const getOfferPdfFilename = (offerId, variant, supplierName) => {
  if (variant === 'supplier') {
    const supplierSlug = slugify(supplierName) || 'supplier';
    return `${offerId}-supplier-${supplierSlug}.pdf`;
  }
  return `${offerId}-${variant === 'internal' ? 'internal' : 'customer'}.pdf`;
};

export const isPdfImageFile = (file = {}) => (
  ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(String(file.fileType || '').toLowerCase())
);

export const getSupplierItemInternalCost = (item = {}) => (
  Number(item.internalPrice ?? item.costFromSupplier ?? 0)
);

export const getSupplierItemCustomerPrice = (item = {}) => (
  Number(item.customerPrice ?? item.unitPrice ?? 0)
);

export const getSupplierItemInternalTotal = (item = {}) => (
  Number(item.internalLineTotal ?? (getSupplierItemInternalCost(item) * Number(item.qty || 0)))
);

export const getSupplierItemCustomerTotal = (item = {}) => (
  Number(item.total ?? (
    getSupplierItemCustomerPrice(item)
    * Number(item.qty || 0)
    * (1 - (Number(item.discount) || 0) / 100)
  ))
);

export const getOfferPdfSearchText = ({ order = {}, supplierSections = [], lead = {}, variant = 'internal' }) => {
  const isInternal = variant === 'internal';
  const values = [
    order.id,
    order.type,
    order.client,
    order.date,
    order.descriptionToCustomer,
    order.paymentTerms,
    order.deliveryDate,
    lead.address,
    lead.email,
    lead.phone,
  ];

  supplierSections.forEach((section) => {
    if (isInternal) values.push(section.displayName || section.name);
    (section.items || []).forEach((item) => {
      values.push(
        item.description || item.productName,
        item.article,
        item.qty,
        getSupplierItemCustomerPrice(item),
        getSupplierItemCustomerTotal(item),
        item.brandingDescription,
        item.deliveryRequirements,
        item.notes,
      );
      if (isInternal) {
        values.push(
          `Internal cost ${getSupplierItemInternalCost(item)}`,
          `Internal total ${getSupplierItemInternalTotal(item)}`,
        );
      }
      (item.files || []).forEach((file) => values.push(file.fileName));
    });
  });

  return values.filter((value) => value !== undefined && value !== null && value !== '').join(' ');
};
